import './Loader.scss';

const Loader = () => {
    return (
        <div className='a-loader-spinner-container'>
            <span className="a-loader-spinner"></span>
        </div>
    )
}

export default Loader